import { Capacitor } from "@capacitor/core";
import { DiamondPaymentProvider, type PaymentProvider } from "@yjsgames/payment-ports";
import type { EconomyController } from "../systems/EconomyController.js";
import type { AnalyticsSink } from "@yjsgames/analytics-ports";

export interface PaymentProviderConfig {
  readonly analytics: AnalyticsSink;
  /** economy getter 주입 — applySaveData의 인스턴스 교체에 안전(stale 회피). */
  readonly economyRef: () => EconomyController;
  /** productId → 레거시 다이아 폴백 가격. 광고 제거 IAP는 스토어 전용이라 0을 사용한다. */
  readonly diamondPriceOf: (productId: string) => number;
  /** 네이티브 빌링 구현이 async 로드되면 통지 — 호출자가 교체 보관(광고 패턴 동형). */
  readonly onNativeProvider?: (provider: PaymentProvider) => void;
}

/**
 * 결제 Provider 결정 (DIP 플랫폼 분기 팩토리, `createRewardedAdProvider`와 1:1 대칭).
 * - 웹/dev: `DiamondPaymentProvider`를 동기 반환하되 IapFlow가 스토어 미조회 상품 구매를 차단한다.
 * - 네이티브: 우선 폴백을 반환하고 `GooglePlayBillingProvider`를 dynamic import로 교체한다
 *   (웹 번들에서 @capgo SDK 제외 + 첫 구매 전 교체 완료). `onNativeProvider`로 교체분을 통지.
 *
 * 게임 로직(상점)은 반환된 `PaymentProvider`(Port)에만 의존하고 구체 구현을 모른다.
 */
export function createPaymentProvider(config: PaymentProviderConfig): PaymentProvider {
  const fallback = new DiamondPaymentProvider(config.economyRef, config.diamondPriceOf);
  if (Capacitor.isNativePlatform()) {
    void import("./GooglePlayBillingProvider.js").then(({ GooglePlayBillingProvider }) => {
      config.onNativeProvider?.(new GooglePlayBillingProvider(config.analytics));
    });
  }
  return fallback;
}
